import React from 'react';
import FacebookIcon from '../../../../assets/icons/inline/facebook.inline.svg';
import TwitterIcon from '../../../../assets/icons/inline/twitterLogo.inline.svg';
import LinkedInIcon from '../../../../assets/icons/inline/linked-in.inline.svg';
import InstIcon from '../../../../assets/icons/inline/inst.inline.svg';
import YoutubeIcon from '../../../../assets/icons/inline/youtube.inline.svg';
import { SocialNetworkType } from '../../../../interfaces/professional/Professional';

const SocialIcon = ({ icon }: { icon: SocialNetworkType }) => {
  if (icon === SocialNetworkType.Facebook) {
    return <FacebookIcon />;
  }
  if (icon === SocialNetworkType.Instagram) {
    return <InstIcon />;
  }
  if (icon === SocialNetworkType.Twitter) {
    return <TwitterIcon />;
  }
  if (icon === SocialNetworkType.LinkedIn) {
    return <LinkedInIcon />;
  }
  if (icon === SocialNetworkType.Youtube) {
    return <YoutubeIcon />;
  }
  return null;
};

export default SocialIcon;
